import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface ProviderContactInfo {
  phone: string;
  email: string;
  whatsapp?: string;
  address: string;
}

export const useProviderContact = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [contactInfo, setContactInfo] = useState<ProviderContactInfo | null>(null);

  const fetchContactInfo = async (providerId: string): Promise<ProviderContactInfo | null> => {
    setIsLoading(true);
    setError(null);

    try {
      const { data, error: fnError } = await supabase.functions.invoke('get-provider-contact', {
        body: { provider_id: providerId }
      });

      if (fnError) {
        throw fnError;
      }

      if (data.error) {
        setError(data.message || data.error);
        return null;
      }

      setContactInfo(data.contact);
      return data.contact;
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to fetch contact info';
      setError(message);
      console.error('[useProviderContact] Error:', err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    fetchContactInfo,
    contactInfo,
    isLoading,
    error,
  };
};
